<template>
    <div class="print-config-question">
        <print-config-layout>
            <template #icon class="print-config-layout__icon">
                <component v-if="questionIcon" :is="iconComponent" class="print-config-icon--small" />
            </template>
            <template #text class="print-config-layout__text">
                <h4 v-if="isFirstLevel">{{config.title}}</h4>
                <p v-else>{{config.question}}</p>
            </template>
            <template #answer class="print-config-layout__answer">
                <e-evaluation-circle
                        v-if="!isFirstLevel"
                        :answer="answers.answer"
                />
            </template>
        </print-config-layout>
    </div>
</template>

<script>
    import printConfigLayout from "@pages/print/concrete/print-config-layout"
    import eEvaluationCircle from '@elements/print/e-evaluation-circle'

    export default {
        name: "print-config-question",
        components: {
            printConfigLayout,
            eEvaluationCircle
        },
        data() {
            return {
                hasEvaluationsAsChildren: false
            }
        },
        props: {
            config: {
                type: Object
            },
            answers: {
                type: Object
            },
            questionIcon: {
                type: String
            },
            level: {
                type: Number
            }
        },
        computed: {
            isFirstLevel() {
                return this.level === 1
            },
            iconComponent() {
                return this.questionIcon;
            }
        },
        methods: {
            checkEvaluationsAsChildren() {
                this.config.children.forEach(el => {
                    if (el.type === 'evaluation') this.hasEvaluationsAsChildren = true
                })
            },
        },
        mounted() {
            this.checkEvaluationsAsChildren()
        }
    }
</script>
